import './App.css';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Login from './components/Login';
import ManagerInt from './components/manager/ManagerInterface'; // Mantener por si se usa en la ruta general /Master/*
import { useEffect } from 'react';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

// Importar componentes de módulos
import SmartLinksPage  from './components/smartlinks/pages/SmartLinksPage.jsx';
import Dashboard from './components/manager/managerModules/Dashboard';
import Depositos from './components/manager/managerModules/Movements'; // Asumo Movements.jsx por "Depósitos"
import Transacciones from './components/manager/managerModules/Transactions';
import RecurringPayments from './components/manager/managerModules/RecurringPayments/RecurringPayments';
import Facturas from './components/manager/managerModules/Bills'; // Bills.jsx por "Facturas"
import Aclaraciones from './components/manager/managerModules/Clarifications'; // Clarifications.jsx por "Aclaraciones"
import LinksView from './components/smartlinks/pages/LinksView.jsx';
import LinksTableView from './components/smartlinks/pages/SmartLinkList.jsx';
import { SmartLinksFormBl } from './components/smartlinks/components/SmartLinksFormBl.jsx';
import RegisterPage from './components/register/pages/RegisterPage.jsx';
// Asumo que Cards.jsx, Notices.jsx, Password.jsx, setting.jsx, TransactionsReturn.jsx son otros módulos no mencionados en la barra lateral o manejados internamente por ManagerInt

function App() {
  const location = useLocation();

  useEffect(() => {
    let sectionName = '';

    if (location.pathname.startsWith('/Master')) {
      const pathParts = location.pathname.split('/').filter(part => part);
      sectionName = pathParts[1] || 'Master';
    } else {
      sectionName = 'Inicio';
    }

    document.title = `Peiix Master - ${sectionName}`;
  }, [location]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="App">
        <Routes>
          <Route path='/Inicio/*' element={<Login />} />
          <Route path="/" element={<Navigate to="/Inicio" replace />} />

          <Route 
            path='/Master/Smartlinks/' 
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'GERENTE', "USUARIO"]}>
                <Layout><SmartLinksPage/></Layout> 
              </PrivateRoute>
              }
          />
          <Route 
            path='/Master/SmartlinksList/' 
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'GERENTE', "USUARIO"]}>
                <Layout><LinksTableView/></Layout> 
              </PrivateRoute>
              }
          />
          <Route 
            path='/Master/LinksView/' 
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'GERENTE', "USUARIO"]}>
                <Layout><LinksView/></Layout>  
              </PrivateRoute>
              }
          />

            <Route 
            path='/Master/SmartLinksBL/' 
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'GERENTE', "USUARIO"]}>
                <Layout><SmartLinksFormBl/></Layout>  
              </PrivateRoute>
              }
          />
          

          {/* Rutas protegidas para módulos específicos con verificación de roles */}
          <Route
            path='/Master/Inicio'
            element={
              <PrivateRoute allowedRoles={['ADMIN']}>
                <Layout><Dashboard /></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path='/Master/Depositos'
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'CONTABILIDAD']}>
                <Layout><Depositos /></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path='/Master/Transacciones'
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'GERENTE', 'CAJERO', "USUARIO"]}>
                <Layout><Transacciones /></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path='/Master/Recurrentes'
            element={
              <PrivateRoute allowedRoles={['ADMIN', 'GERENTE']}>
                <Layout><RecurringPayments /></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path='/Master/Facturas'
            element={
              <PrivateRoute allowedRoles={['SUPERADMIN']}>
                <Layout><Facturas /></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path='/Master/Aclaraciones'
            element={
              <PrivateRoute allowedRoles={['SUPERADMIN']}>
                <Layout><Aclaraciones /></Layout>
              </PrivateRoute>
            }
          />

            <Route 
            path='/Register/' 
            element={
                <RegisterPage/>
              }
          />

          {/* Ruta general para otras subrutas de /Master/, protegida solo por token si es necesario */}
          {/* Si ManagerInt maneja otras rutas internas, esta ruta puede ser útil. */}
          {/* Si todas las rutas bajo /Master/ son los módulos definidos arriba, esta ruta puede eliminarse. */}
          <Route path='/Master/*' element={
            <PrivateRoute>
              <ManagerInt />
            </PrivateRoute>
          } />

        </Routes>
      </div>
    </>
  );
}

export default App; // Solo exportamos el App
